// -*- mode: RJSX; js-indent-level: 2; -*-

import { createContext, useContext } from 'react';

export const UndoContext = createContext();
export const useUndo = () => useContext(UndoContext);
